/* ============================================================
   Destination Hair Extensions — Scroll Reveal & Interactions
   "The Departure Lounge" design system
   ============================================================ */

(function() {
  'use strict';

  // --- Scroll Reveal via IntersectionObserver ---
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.dh-reveal, .dh-stagger, .dh-scale-in, .dh-slide-left, .dh-slide-right');
    if (!reveals.length) return;

    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function(el) { el.classList.add('is-visible'); el.classList.add('dh-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.classList.add('dh-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -60px 0px'
    });

    reveals.forEach(function(el) { observer.observe(el); });
  }

  // --- Auto-apply reveal classes to shopify sections ---
  function tagSections() {
    var sections = document.querySelectorAll(
      '.shopify-section:not(.shopify-section-header):not(.shopify-section-footer):not(.shopify-section-announcement-bar)'
    );
    sections.forEach(function(section) {
      if (!section.classList.contains('dh-reveal') && !section.querySelector('.dh-reveal')) {
        section.classList.add('dh-reveal');
      }
    });
  }

  // --- Parallax-lite on hero ---
  function initHeroParallax() {
    var hero = document.querySelector('.slideshow__banner--media img, .slideshow__banner--media video');
    if (!hero) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollY = window.pageYOffset;
          if (scrollY < window.innerHeight) {
            hero.style.transform = 'scale(1.04) translateY(' + (scrollY * 0.15) + 'px)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // --- Smooth counter animation for stat values ---
  function initCounters() {
    var counters = document.querySelectorAll('.dh-stat__value[data-count], .club-lounge-promo__perk-value[data-count]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1200;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = prefix + current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = prefix + target + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  // --- Lazy image fade-in ---
  function initLazyImages() {
    var images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(function(img) {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('loaded');
        });
      }
    });
  }

  // --- Auto-apply animation classes to image-with-text sections ---
  function tagAnimatedSections() {
    var imageTexts = document.querySelectorAll('.image-with-text');
    imageTexts.forEach(function(section, i) {
      var media = section.querySelector('.image-with-text__media-item, .image-with-text__media');
      var content = section.querySelector('.image-with-text__text-item, .image-with-text__content');
      if (media && !media.classList.contains('dh-scale-in')) {
        media.classList.add('dh-scale-in');
      }
      if (content) {
        content.classList.add(i % 2 === 0 ? 'dh-slide-right' : 'dh-slide-left');
      }
    });
  }

  // --- Init everything ---
  function init() {
    tagSections();
    tagAnimatedSections();
    initScrollReveal();
    initHeroParallax();
    initCounters();
    initLazyImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
